import type { AccountBalanceChipProps } from '../components/v2/AccountBalanceChip'
import type { Locale } from '../locales/i18n'
import type { DepositAccountContext } from './depositFlowConfig'

const USD_FORMATTERS = new Map<Locale, Intl.NumberFormat>()

function formatUsd(value: number, locale: Locale): string {
  let formatter = USD_FORMATTERS.get(locale)
  if (formatter === undefined) {
    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    USD_FORMATTERS.set(locale, formatter)
  }
  return formatter.format(value)
}

/** The chip's props; a deprecated preformatted `value` still wins. */
export function accountBalanceChipProps(
  context: DepositAccountContext | undefined,
  locale: Locale,
): AccountBalanceChipProps | undefined {
  if (context === undefined) {
    return undefined
  }
  const { amountUsd, value, ...rest } = context
  return { ...rest, value: value ?? formatUsd(Number(amountUsd), locale) }
}
